import React from 'react';
import classNames from 'classnames';
import {Logos} from 'helpers/enums/logos';

export default function Logo(props) {
  const { logoType, logoClassName, children, height, width, stroke, fill } = props;
  const LogoVariant = Logos[logoType];
  const logoClass = classNames('logo', logoClassName);
  const logoVariantClasses = classNames({
    [`mix-icon_fillColor${fill}`]: fill,
    [`mix-icon_strokeColor${stroke}`]: stroke
  });

  return (
    <i className={logoClass} key={0}>
      <LogoVariant
        className={logoVariantClasses}
        height={height}
        width={width}
      />
      {children}
    </i>
  );
}



// WEBPACK FOOTER //
// ./src/client/components/logos/logo.jsx